import { render } from "./BreakerSettings.vue?vue&type=template&id=19d6b615&scoped=true"
import script from "./BreakerSettings.vue?vue&type=script&lang=js"
export * from "./BreakerSettings.vue?vue&type=script&lang=js"

import "./BreakerSettings.vue?vue&type=style&index=0&id=19d6b615&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d6b615"]])

export default __exports__